import type { ReactNode } from "react"
import { Link } from "react-router"

function HeartIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-7 w-7" aria-hidden>
      <path d="M12 20.4S5 16.3 3.3 12.2c-1.1-2.6.2-5.4 2.9-6.1 2.2-.6 4 .7 5.1 2.2 1.1-1.5 2.9-2.8 5.1-2.2 2.7.7 4 3.5 2.9 6.1C19 16.3 12 20.4 12 20.4Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export function DonorEmptyState({
  title,
  description,
  primaryLabel,
  primaryTo,
  secondaryLabel,
  secondaryTo,
  icon = <HeartIcon />,
}: {
  title: string
  description: string
  primaryLabel?: string
  primaryTo?: string
  secondaryLabel?: string
  secondaryTo?: string
  icon?: ReactNode
}) {
  return (
    <div className="rounded-2xl border border-gold-500 bg-white px-6 py-10 text-center shadow-sm sm:px-10">
      <div className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-cream-200 text-forest-700">
        {icon}
      </div>
      <h2 className="mt-5 font-display text-2xl font-bold text-ink">{title}</h2>
      <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-ink/65">{description}</p>
      {(primaryLabel || secondaryLabel) && (
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          {primaryLabel && primaryTo && (
            <Link to={primaryTo} className="rounded-full bg-forest-950 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-forest-800">
              {primaryLabel}
            </Link>
          )}
          {secondaryLabel && secondaryTo && (
            <Link to={secondaryTo} className="rounded-full border border-ink/20 px-5 py-2.5 text-sm font-semibold text-ink transition-colors hover:bg-cream-100">
              {secondaryLabel}
            </Link>
          )}
        </div>
      )}
    </div>
  )
}
